import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "eu-west-1",
    aws_cognito_identity_pool_id: "eu-west-1:c9152aba-5723-4e03-92b2-88be689a8dbd",
    aws_user_pools_id: "eu-west-1_9cyiSIsjF",
    aws_user_pools_web_client_id: "n71bdeb3u5dkoj6fqulsa9jkj",
    Auth: {
      identityPoolId: "eu-west-1:c9152aba-5723-4e03-92b2-88be689a8dbd",
      region: "eu-west-1",
      userPoolId: "eu-west-1_9cyiSIsjF",
      userPoolWebClientId: "n71bdeb3u5dkoj6fqulsa9jkj",
    },
    oauth: {
      domain: "whs-safer-beta-mena.auth.eu-west-1.amazoncognito.com",
      redirectSignIn: "https://beta.mena.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.mena.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
